import React, { useEffect, useState } from "react";
import { Offcanvas, Nav, Navbar, Button } from "react-bootstrap";
import Dropdown from "react-bootstrap/Dropdown";
import DropdownItem from "react-bootstrap/esm/DropdownItem";
import MenuIcon from "../assets/images/menu-icon.png";
import TelegramIcon from "../assets/images/telegramIcon.svg";
import WhatsappIcon from "../assets/images/whatsappIconnew.png";
import NotificationIcon from "../assets/images/notificationIcon.svg";
import UserIcon from "../assets/images/user-icon.svg";
import UserImg from "../assets/images/user-img.png";
import BalanceIcon from "../assets/images/balance-icon.png";
import CashierIconNew from "../assets/images/Plus.png";
import WalletIcon from "../assets/images/WalletIcon.png";
import BetIcon from "../assets/images/BetIcon.png";
import AcStatement from "../assets/images/AcStatement.png";
import AcSettings from "../assets/images/AcSettings.svg";
import MoonLight from "../assets/images/moon.svg";
import SunLight from "../assets/images/sunny.svg";

import { FaRegMoneyBillAlt } from "react-icons/fa";
import { MdOutlineVerified } from "react-icons/md";
import { BiSupport } from "react-icons/bi";
import { AiOutlineFileDone } from "react-icons/ai";
import LogoutIconImg from "../assets/images/logout.png";
import { useLocation, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { logoutUser } from "../redux/auth/actions";
import { Link } from "react-router-dom";
import logo from "../assets/images/mmplay.png";
import BonusImg from "../assets/images/bonus.png";
import refferal from "../assets/images/refferal.png";
import MobLeftbar from "./MobLeftbar";
import { AiOutlineSearch } from "react-icons/ai";
import GamesSearchModal from "../views/components/GamesSearchModal";
import numberWithCommas from "../utils/numbersWithComma";

import DepositIcon from "../assets/images/icons/payment.png";
import WithdrawIcon from "../assets/images/icons/cash-withdrawal.png";
import UserIconNew from "../assets/images/icons/user.png";
import { handleLeftSideBar } from "../redux/app/actions";

const HeaderAfterLogin = () => {
  const { user, balance, wallet } = useSelector((state) => state.auth);
  const [show, setShow] = useState(false);
  const [show1, setShow1] = useState(false);
  const navigate = useNavigate();
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  const handleShow1 = () => dispatch(handleLeftSideBar(!showLeftSideBar));
  const { showLeftSideBar } = useSelector((state) => state.app);

  const dispatch = useDispatch();
  const { appDetails } = useSelector((state) => state.app);
  const [isClassAdded, setIsClassAdded] = useState(false);
  useEffect(() => {
    const isClassAddedLocalStorage = localStorage.getItem("isClassAdded");
    if (isClassAddedLocalStorage) {
      setIsClassAdded(true);
      document.body.classList.add("light-theme");
    }
  }, []);
  const toggleClass = () => {
    if (isClassAdded) {
      setIsClassAdded(false);
      localStorage.removeItem("isClassAdded");
      document.body.classList.remove("light-theme");
    } else {
      setIsClassAdded(true);
      localStorage.setItem("isClassAdded", true);
      document.body.classList.add("light-theme");
    }
  };

  const location = useLocation();
  const [activePage, setActivePage] = useState("");
  const headerPages = [
    "sports",
    "sportsbook",
    "inplay",
    "live-dealer",
    "betby",
    "evolution",
    "aviator",
    "/",
  ];
  useEffect(() => {
    const matchedValue = headerPages.find((f) =>
      location?.pathname.includes(f)
    );
    if (matchedValue) {
      setActivePage(matchedValue);
    }
  }, [location]);

  const htmlElement = document.documentElement;
  useEffect(() => {
    if (showLeftSideBar) {
      htmlElement.style.overflow = "hidden";
    } else {
      htmlElement.style.overflow = "auto";
    }
  }, [showLeftSideBar]);

  // console.log("balance", wallet);
  return (
    <>
      <header className="header afterlogin">
        <div className="container">
          <div className="row">
            <div className="col-12">
              <div className="d-flex align-items-center">
                <Button
                  variant="primary menu-btn"
                  onClick={handleShow1}
                  className="d-block d-md-none"
                >
                  <img src={MenuIcon} alt="User Menu Icon" width={25} />
                </Button>

                <div className="logo">
                  <a href="/sports">
                    <img src={appDetails?.LOGO_URL} alt="Logo" />
                  </a>
                </div>

                <div className="headerRight ms-auto">
                  <div className="me-2">
                    <GamesSearchModal />
                  </div>
                  <ul>
                    <li className="d-none">
                      <a
                        class="wtp"
                        href={
                          appDetails?.WHATS_APP_URL != ""
                            ? `https://wa.me/${appDetails?.WHATS_APP_URL}`
                            : "javascript:void(0)"
                        }
                        target={appDetails?.WHATS_APP_URL != "" ? "_blank" : ""}
                      >
                        <img src={WhatsappIcon} alt="Whatsapp Icon" />
                      </a>
                    </li>
                    <li className="balance">
                      <div className="balance-amount" href="/cashier">
                        <div>Balnce: {wallet?.balance}</div>
                        <div>Bonus: {numberWithCommas(wallet?.coins)}</div>
                      </div>
                    </li>
                    <li className="head-social">
                      <a
                        href={
                          appDetails.TELEGRAM != ""
                            ? appDetails.TELEGRAM
                            : "javascript:void(0)"
                        }
                        target={appDetails.TELEGRAM != "" ? "_blank" : ""}
                      >
                        <img src={TelegramIcon} alt="telegram" />
                      </a>
                    </li>
                    <li className="d-none">
                      <a
                        className="head-social"
                        href={
                          appDetails?.WHATS_APP_URL != ""
                            ? `https://wa.me/${appDetails?.WHATS_APP_URL}`
                            : "javascript:void(0)"
                        }
                        target={appDetails?.WHATS_APP_URL != "" ? "_blank" : ""}
                      >
                        <img src={WhatsappIcon} alt="whatsapp" />
                      </a>
                    </li>
                    {/* <div className="searchbar">
                    <AiOutlineSearch />
                  </div> */}
                  </ul>

                  {/* <Button variant="primary menu-btn toggle" onClick={handleShow}>
                  <span className="d-none d-md-block">{user?.mstruserid}</span>
                  <div className="d-md-none">
                    <img src={UserIcon} alt="User Menu Icon" width={25} />
                  </div>
                </Button> */}

                  <Dropdown className="dropdownMenu">
                    <Dropdown.Toggle
                      variant="success"
                      id="dropdown-basic"
                      className="d-md-block d-none"
                    >
                      {user?.mstruserid}
                    </Dropdown.Toggle>
                    <Dropdown.Toggle
                      variant="success"
                      id="dropdown-basic"
                      className="d-md-none d-block"
                    >
                      <img src={UserImg} alt="usericon" />
                    </Dropdown.Toggle>

                    <Dropdown.Menu>
                      <div className="d-flex d-md-none d-block">
                        <div className="profile-img">
                          <img src={UserIcon} alt="User Icon" />
                        </div>
                        <div className="user-info">
                          <Link className="user_name" to="/profile">
                            {user?.mstruserid}
                          </Link>
                          <p>{user?.mobileno}</p>
                        </div>
                      </div>
                      <Dropdown.Item href="javascript:void(0)">
                        <div className="row">
                          <div className="col-6">
                            <div className="balance mb-4">
                              {/* <img src={WalletIcon} alt="wallet" /> */}
                              Balance
                            </div>
                          </div>
                          <div className="col-6">
                            <div className="balance-amount mb-4">
                              {" "}
                              INR {wallet?.balance}
                            </div>
                          </div>

                          <div className="col-6">
                            <div className="balance mb-4">
                              {/* <img src={WalletIcon} alt="wallet" /> */}
                              Bonus
                            </div>
                          </div>
                          <div className="col-6">
                            <div className="balance-amount mb-4">
                              {" "}
                              {wallet?.coins}
                            </div>
                          </div>

                          <div
                            className="col-6"
                            onClick={() => {
                              navigate("/withdraw");
                            }}
                          >
                            <Button variant="" className="btn_withdraw w-100">
                              Withdraw
                            </Button>
                          </div>
                          <div
                            className="col-6"
                            onClick={() => {
                              navigate("/gatewaylist");
                            }}
                          >
                            <Button
                              variant="primary"
                              className="btn_primary w-100"
                            >
                              Deposit
                            </Button>
                          </div>
                        </div>
                      </Dropdown.Item>
                      <DropdownItem href="/profile">
                        <img src={UserIconNew} alt="my bet" />
                        <span>Profile</span>
                      </DropdownItem>
                      <Dropdown.Item href="/mybets">
                        <img src={BetIcon} alt="my bet" />
                        <span>My Bets</span>
                      </Dropdown.Item>
                      <Dropdown.Item href="/bonus" className="img_size">
                        <img src={BonusImg} />
                        <span className="bonus-space">Bonus</span>
                      </Dropdown.Item>
                      <Dropdown.Item href="/referral" className="img_size">
                        <img src={refferal} />

                        <span className="bonus-space">Referral</span>
                      </Dropdown.Item>
                      <Dropdown.Item href="/cashier">
                        <img src={AcStatement} alt="account statement" />
                        <span>Account Statement</span>
                      </Dropdown.Item>
                      <DropdownItem>
                        <li
                          onClick={() => dispatch(logoutUser())}
                          className="Logout"
                        >
                          <a href="/">
                            {/* <LogoutIcon /> */}

                            <span>Sign Out</span>
                            <img src={LogoutIconImg} />
                          </a>
                        </li>
                      </DropdownItem>
                    </Dropdown.Menu>
                  </Dropdown>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="header-menu">
          <ul className="mx-auto">
            <li className={activePage == "sports" ? "active" : ""}>
              <a href="/sports">Home</a>
            </li>
            <li className={activePage == "inplay" ? "active" : ""}>
              <a href="/sportsbook/Inplay">Sportsbook</a>
            </li>
            {/* <li>
              <a href="/betby">IPL</a>
            </li>
            <li className={activePage == "betby" ? "active" : ""}>
              <a href="/betby">Sports</a>
            </li> */}
            <li className={activePage == "live-dealer" ? "active" : ""}>
              <a href="/live-dealer">Live Dealers</a>
            </li>
            <li className={activePage == "evolution" ? "active" : ""}>
              <a href="/casino/evolution">Game Shows</a>
            </li>
            <li className={activePage == "aviator" ? "active" : ""}>
              <a href="/casino/spribe/aviator">Aviator</a>
            </li>
          </ul>
        </div>

        <Offcanvas
          className="user_section"
          show={show}
          onHide={handleClose}
          placement={"end"}
        >
          <Offcanvas.Header closeButton="closeButton" closeVariant="white">
            <Offcanvas.Title>
              <div className="d-flex">
                <div className="profile-img">
                  <img src={UserIcon} alt="User Icon" />
                </div>
                <div className="user-info">
                  <Link className="user_name" to="/profile">
                    {user?.mstruserid}
                  </Link>
                  <p>{user?.mobileno}</p>
                </div>
              </div>
            </Offcanvas.Title>
          </Offcanvas.Header>
          <Offcanvas.Body>
            <div className="container upperbalnace">
              <div className="row">
                <div className="col-6">
                  <div className="balance mb-4">
                    <img src={WalletIcon} alt="wallet" />
                    Balance
                  </div>
                </div>
                <div className="col-6">
                  <div className="balance-amount mb-4">
                    {" "}
                    INR {wallet?.balance}
                  </div>
                </div>
                {/* <div className="col-12">
                <div className="non_cash_balance">
                  <h6 className="non_cash_balance_heading">
                    <span>
                      <strong> Bonus</strong> <small>Non-Cash-Balance </small>{" "}
                    </span>
                    <span>
                      <strong>{wallet?.coins}</strong>
                    </span>
                  </h6>
                </div>
              </div> */}
                <div
                  className="col-6"
                  onClick={() => {
                    navigate("/withdraw");
                  }}
                >
                  <Button variant="" className="btn_withdraw w-100">
                    Withdraw
                  </Button>
                </div>
                <div
                  className="col-6"
                  onClick={() => {
                    navigate("/gatewaylist");
                  }}
                >
                  <Button variant="primary" className="btn_primary w-100">
                    Deposit
                  </Button>
                </div>
              </div>
            </div>
            <ul className="menu-items">
              {/* <li>
              <a href="/profile">
                <FaRegUserCircle />
                <span>Profile</span>
              </a>
            </li> */}
              <li>
                <a href="/mybets">
                  <img src={BetIcon} alt="my bet" />
                  <span>My Bets</span>
                </a>
              </li>
              <li>
                <a href="/bonus" className="img_size">
                  <img src={BonusImg} />
                  <span className="bonus-space">Bonus</span>
                </a>
              </li>
              <li>
                <a href="/referral" className="img_size">
                  <img src={refferal} />

                  <span className="bonus-space">Referral</span>
                </a>
              </li>
              <li>
                <a href="/cashier">
                  <img src={AcStatement} alt="account statement" />
                  <span>Account Statement</span>
                </a>
              </li>

              <li onClick={() => dispatch(logoutUser())}>
                <a href="/">
                  {/* <LogoutIcon /> */}
                  <img src={LogoutIconImg} />
                  <span>Sign Out</span>
                </a>
              </li>
            </ul>

            <div className="theme-btn">
              <buton type="button" className="btn" onClick={toggleClass}>
                <img src={MoonLight} alt="moon" className="dark_theme" />
                <img src={SunLight} alt="sun" className="light_theme" />
              </buton>
            </div>
          </Offcanvas.Body>
        </Offcanvas>
      </header>

      {showLeftSideBar && (
        <MobLeftbar
          className="d-block d-md-none"
          setShowAuthModals={() => {}}
        />
      )}
    </>
  );
};

export default HeaderAfterLogin;
